import type { EmailTemplatesState } from '../../store/emailTemplates/emailTemplatesTypes';

/**
 * Dynamic reducer key under which the email-templates slice is registered via
 * `useDynamicReducer`. State is exposed at `state.dynamic[emailTemplatesReducerName]`,
 * consistent with the rest of the PBT UI (see useCRMCases / UserRoles).
 */
export const emailTemplatesReducerName = 'emailTemplatesReducer';

/** Default slice used before the dynamic reducer has been registered. */
export const defaultEmailTemplatesState: EmailTemplatesState = {
  templates: [],
  selectedTemplate: null,
  variables: [],
  previewResult: null,
  loading: false,
  error: null,
  correlationId: null,
  saving: false,
  saveSuccess: false,
  previewing: false,
};

/** Selects the email-templates slice from the framework's dynamic reducer registry. */
export const selectEmailTemplatesState = (state: {
  dynamic?: Record<string, unknown>;
}): EmailTemplatesState =>
  (state?.dynamic?.[emailTemplatesReducerName] as EmailTemplatesState) ?? defaultEmailTemplatesState;
